import { ActionContext } from 'vuex';

import { TableSortTypes } from '@/common/components/redesigned/Table/types/tableTypes';
import { TBaseFilterPayload } from '@/common/types/filter.js';
import { getLocalState } from '@/common/utils/store';

import { FEREventVedRequestDto, TEventsFilterData, TEventsFilterDataWithoutSortingPayload } from '../../types/events';
import { EVENTS_VES_ACTIONS_NAME, EVENTS_VES_MUTATIONS_NAME } from './name';
import { TEventsState } from './types';

import { TPaginationParams } from '@/types/meta.js';
import links from '@/utils/links';
import request from '@/utils/request';

// Общий TableComponent при клике по колонке шлёт sortColumn/sortOrder,
// а getcombinedevents понимает только isIncreasingOrder (bool). Приводим.
const mapEventsSortParams = (params: Record<string, unknown>): Record<string, unknown> => {
  if (!('sortOrder' in params)) return params;

  const result = { ...params };
  result.isIncreasingOrder = result.sortOrder === TableSortTypes.ASCEND;
  delete result.sortColumn;
  delete result.sortOrder;

  return result;
};

export async function getEventsTable(
  context: ActionContext<TEventsState, unknown>,
  payload: TBaseFilterPayload<TEventsFilterData & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.events.getCombined,
      name: EVENTS_VES_ACTIONS_NAME.getEventsTable,
      abortController: payload.abortController,
    },
    mapEventsSortParams(payload.params as Record<string, unknown>),
  );
}

export async function getMinistryEventsTable(
  context: ActionContext<TEventsState, unknown>,
  payload: TBaseFilterPayload<TEventsFilterData & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.events.getCombined,
      name: EVENTS_VES_ACTIONS_NAME.getMinistryEventsTable,
      abortController: payload.abortController,
    },
    mapEventsSortParams(payload.params as Record<string, unknown>),
  );
}

export async function getIndicatorCards(
  context: ActionContext<TEventsState, unknown>,
  payload: TEventsFilterDataWithoutSortingPayload,
) {
  return request(
    context,
    {
      url: links.ves.events.getIndicatorCards,
      mutate: getLocalState(EVENTS_VES_MUTATIONS_NAME.setIndicatorCards),
      name: EVENTS_VES_ACTIONS_NAME.getIndicatorCards,
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function createEvent(context: ActionContext<TEventsState, unknown>, payload: FEREventVedRequestDto) {
  return request(
    context,
    {
      url: links.ves.events.create,
      method: 'post',
      name: EVENTS_VES_ACTIONS_NAME.createEvent,
    },
    payload,
  );
}

export async function updateEvent(
  context: ActionContext<TEventsState, unknown>,
  { id, data }: { id: number; data: FEREventVedRequestDto },
) {
  return request(
    context,
    {
      url: `${links.ves.events.update}/${id}`,
      method: 'put',
      name: EVENTS_VES_ACTIONS_NAME.updateEvent,
    },
    data,
  );
}

export async function deleteEvent(context: ActionContext<TEventsState, unknown>, id: number) {
  return request(
    context,
    {
      url: `${links.ves.events.delete}/${id}`,
      method: 'delete',
      name: EVENTS_VES_ACTIONS_NAME.deleteEvent,
    },
    {},
  );
}

export async function getEventById(context: ActionContext<TEventsState, unknown>, id: number) {
  return request(
    context,
    {
      url: `${links.ves.events.getById}/${id}`,
      method: 'get',
      name: EVENTS_VES_ACTIONS_NAME.getEventById,
    },
    {},
  );
}
